import i18n from 'i18n';
import { formatDate } from '../../usefulFunctions';
import { env } from '../../env';
const baseUrlApi = env.REACT_APP_API_SERVER;

const modifyRegisterRequest = async (register, since, until) => {
    let lang = 'es';
    let dateFrom = await since;
    let dateTo = await until;
    i18n.language == 'en' ? (lang = 'us') : null;
    const url = baseUrlApi + 'RegisterName/UpdateById';
    const bodyRequest = {
        id_register_type: register.id_register_type,
        id_register: register.id_register,
        id_register_name: register.id_register_name,
        date_from: formatDate(dateFrom),
        date_to: formatDate(dateTo),
        name: register.name,
        creation_user: register.creation_user,
        creation_date: register.creation_date,
        modification_user: register.modification_user,
        modification_date: register.modification_date
    };
    let token = JSON.parse(localStorage.getItem('tokens'));
    const myAuthorizationHeader = `Bearer ${token.access_token}`;
    try {
        const response = await fetch(url, {
            method: 'PUT',
            // Adding headers to the request
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                'Accept-Language': lang,
                Authorization: myAuthorizationHeader
            },
            body: JSON.stringify(bodyRequest)
        });
        return response;
    } catch (error) {
        let response = { status: -1, text: 'Error de comunicación' };
        return response;
    }
};

export default modifyRegisterRequest;
